// extracted by mini-css-extract-plugin
module.exports = {"page-with-sidebar":"styles_page-with-sidebar__wXD3I","page-with-sidebar__children":"styles_page-with-sidebar__children__kqZmt"};